import React from 'react';

import { zl } from '../../../../functions/utilities';
import { dataFormat } from '../../../../functions/dataFormat';
import { sortByDateDesc } from '../../../../functions/utilities';

const ZbiorowyKomornikTablePrzelewy = (props) => {

    const { przelewy_g, sumaPrzelewyTenRok} = props;

    const przelewy_rok = przelewy_g?.filter( p => new Date(p?.data_operacji).getFullYear() == new Date().getFullYear());

    const przelewy_sort = przelewy_rok?.length > 0 ? sortByDateDesc(przelewy_rok, "data_operacji") : [];

    const tab = przelewy_sort?.map( (p, i) => (
        <tr key={i}>
            <td style={{
                textAlign: "center",
                padding: "4px 5px",
                border: "1px solid black"
            }}>
                {dataFormat(p.data_operacji)}
            </td>
            <td style={{
                textAlign: "right",
                padding: "4px 5px",
                border: "1px solid black"
            }}>
                {zl(p.kwota)}
            </td>
        </tr>
    ))

    return (
        <div>
            <table
                style={{
                    border: "1px solid black", 
                    fontSize: "11px"
                }}
            >
                <thead>
                    <tr>
                        <th
                            style={{
                                border: "1px solid black",
                                padding: "4px 15px"}}
                        >
                            Data wpłaty
                        </th>
                        <th
                            style={{
                                border: "1px solid black",
                                padding: "4px 15px"}}
                        >
                            Wpłaty
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {tab}
                </tbody>
                <tfoot>
                    <tr>
                        <td style={{
                            textAlign: "center",
                            padding: "4px 5px",
                            border: "1px solid black"
                        }}>
                            Razem
                        </td>
                        <td style={{
                            textAlign: "right",
                            padding: "4px 5px",
                            border: "1px solid black"
                        }}>
                            {zl(sumaPrzelewyTenRok)}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default ZbiorowyKomornikTablePrzelewy;